export default "__VITE_PUBLIC_ASSET__0fdbef41__"